<template>
  <div>
    <highcharts ref="chart" :options="options" />
    <br />
    <b-table
      :striped="true"
      :narrowed="true"
      :hoverable="true"
      :data="values"
      :columns="columns"
    />
  </div>
</template>

<script>
import Travel from '@/models/carbon/Travel.js'
import '@/plugins/highcharts.js'

export default {
  name: 'TravelsAndVehiclesDistancesBar',
  props: {
    ghgi: {
      type: Object,
      default: null
    }
  },
  computed: {
    total: function () {
      let total = 0
      for (let i in Travel.transportations) {
        total += this.ghgi.emissions.travels.transportations.distances[i]
      }
      return total
    },
    values: function () {
      let i = 0
      let obj = { label: '<nobr>' + this.$t('distances.km') + '</nobr>' }
      let objp = {
        label:
          '<nobr>' +
          this.$t('compGraphicsTravelsAndVehiclesDistancesBar.label-1') +
          '</nobr>'
      }
      for (let category of Travel.transportations) {
        obj[category] =
          '<nobr>' +
          this.$options.filters.splitNumber(
            this.ghgi.emissions.travels.transportations.distances[i]
          ) +
          '</nobr>'
        objp[category] =
          (
            (this.ghgi.emissions.travels.transportations.distances[i] /
              this.total) *
            100
          ).toFixed(2) + ' %'
        i += 1
      }
      return [obj, objp]
    },
    columns: function () {
      let columns = [
        {
          field: 'label',
          label: '',
          sticky: true
        }
      ]
      for (let category of Travel.transportations) {
        columns.push({
          field: category,
          label: category,
          numeric: true
        })
      }
      return columns
    },
    options: function () {
      return {
        chart: {
          type: 'column'
        },
        title: {
          text: ''
        },
        series: [
          {
            showInLegend: false,
            data: this.ghgi.emissions.travels.transportations.distances
          }
        ],
        xAxis: {
          categories: Travel.transportations.map((value) => this.$t(value)),
          crosshair: true
        },
        yAxis: {
          min: 0,
          title: {
            text: this.$t('distances.km')
          }
        },
        tooltip: {
          pointFormat: '<b>{point.y} km</b>',
          valueDecimals: 0
        }
      }
    }
  }
}
</script>

<style>
.is-sticky {
  background: #fafafa !important;
}
.table td {
  vertical-align: middle !important;
}
</style>
